import React, { useState } from 'react';
import Header from '../../components/header/header';
import { Link } from 'react-router-dom';
import './departments.scss';
import { motion, AnimatePresence } from "motion/react";

const departments = [
  {
    img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771527517/0A3A2618_halbc6.jpg",
    tag: "Worship",
    title: "Amazing Grace Levites",
    desc: "Our worship team uses musical gifts to lead the congregation in praise and worship, creating an atmosphere of God's presence.",
    schedule: "Sundays & Rehearsals",
    details: {
      overview: "The Amazing Grace Levites is the heartbeat of our Sunday experience. Our team of singers, musicians, and technicians work together to create an atmosphere where everyone can encounter the presence of God.",
      whatWeDo: [
        "Lead Sunday morning worship services",
        "Weekly rehearsals to develop musicianship and spiritual depth",
        "Plan and coordinate worship sets aligned with the message",
        "Support special events, conferences, and outreach programs",
        "Mentor and develop emerging worship leaders"
      ],
      whoCanJoin: "Anyone with a passion for worship and a musical gift — vocalists, instrumentalists, and sound/tech operators are all welcome. No professional experience required, just a heart for God and a willingness to grow.",
    }
  },
  {
    img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771542943/0A3A1897_yntui5.jpg",
    tag: "Men's Ministry",
    title: "Men of Valor",
    desc: "Empowering men to be bold leaders, faithful servants, and spiritual warriors in their families, church, and community.",
    schedule: "Monthly Meetings",
    details: {
      overview: "Men of Valor is dedicated to building strong, godly men who lead with courage and integrity. We believe every man has a calling to be a spiritual warrior and faithful servant.",
      whatWeDo: [
        "Monthly men's fellowship and teaching sessions",
        "Accountability groups and mentorship programs",
        "Service projects and community outreach",
        "Men's retreats, camps, and conferences",
        "Leadership development for men of all ages"
      ],
      whoCanJoin: "All men who desire to grow in their faith and become the leaders God has called them to be. Whether you're a new believer or seasoned in faith, there's a place for you.",
    }
  },
  {
    img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771527522/0A3A7670_o0n3am.jpg",
    tag: "Women's Ministry",
    title: "Royal Amazing Women",
    desc: "Building a community of women who encourage, support, and inspire one another to live out their royal identity in Christ.",
    schedule: "Monthly Gatherings",
    details: {
      overview: "Royal Amazing Women exists to help women discover their identity and purpose in Christ. We create a space where women feel valued, empowered, and equipped to make a difference.",
      whatWeDo: [
        "Monthly women's fellowship and Bible study",
        "Prayer gatherings and spiritual growth sessions",
        "Community service and outreach projects",
        "Women's conferences, retreats, and special events",
        "Mentorship and discipleship programs"
      ],
      whoCanJoin: "All women seeking to grow in faith, build meaningful relationships, and discover their God-given purpose. All ages and seasons of life are welcome.",
    }
  },
  {
    img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771542943/0A3A3538_yyx88t.jpg",
    tag: "Youth",
    title: "The Emerge Church (Youth Ministry)",
    desc: "Dynamic youth ministry helping teenagers discover their identity in Christ and live out their faith boldly.",
    schedule: "Fridays 6:30 PM",
    details: {
      overview: "The Emerge Church exists to help teenagers discover who they are in Christ and live out their faith boldly. We create a space where young people feel seen, known, and empowered to make a difference.",
      whatWeDo: [
        "Weekly Friday night services with worship, teaching, and community",
        "Small group discipleship and one-on-one mentorship",
        "Youth retreats, camps, and conferences",
        "Community service projects and outreach events",
        "Leadership development for student leaders"
      ],
      whoCanJoin: "Middle and high school students looking to grow in their faith. Adult volunteers who have a heart for teenagers and want to mentor and support young people are also welcome.",
    }
  },
  {
    img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771527518/0A3A9457_gdtwpx.jpg",
    tag: "Children",
    title: "AGC Teens & Pre-Teens",
    desc: "Engaging ministry for pre-teens and young teenagers, helping them build a strong foundation of faith during critical years.",
    schedule: "Sundays 11:00 AM",
    details: {
      overview: "AGC Teens & Pre-Teens ministry is dedicated to walking alongside young people during their formative years, helping them develop a personal relationship with Jesus.",
      whatWeDo: [
        "Age-appropriate Bible teaching and worship",
        "Interactive lessons, games, and activities",
        "Character development and life skills training",
        "Special events, camps, and outings",
        "Mentorship and small group connections"
      ],
      whoCanJoin: "Pre-teens and young teenagers (ages 10-14). Adult volunteers passionate about investing in the next generation and creating a safe, fun environment are needed.",
    }
  },
  {
    img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771527519/0A3A1972_pj0rbi.jpg",
    tag: "Hospitality",
    title: "Welcoming / Ushering",
    desc: "Creating a warm, friendly atmosphere by greeting guests and helping everyone feel at home from the moment they arrive.",
    schedule: "Sundays",
    details: {
      overview: "The Welcoming and Ushering team is the first face people see when they walk through our doors. We believe that a warm welcome can change someone's entire experience of church and open their heart to the Gospel.",
      whatWeDo: [
        "Greet and welcome guests and members every Sunday",
        "Assist with seating and facility navigation",
        "Distribute programs and connect newcomers with resources",
        "Manage parking and directional support",
        "Coordinate hospitality for special events and services"
      ],
      whoCanJoin: "Anyone who loves people and has a gift for making others feel at home. No prior experience needed — just a friendly smile and a servant's heart.",
    }
  },
  {
    img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771543384/51dcb161-deb2-4feb-90f8-ae262aba6e05_n4lujg.jpg",
    tag: "Outreach",
    title: "AGC Outreach & Public Relations",
    desc: "Connecting our church with the community through service, compassion, and sharing the love of Christ beyond our walls.",
    schedule: "Monthly Events",
    details: {
      overview: "AGC Outreach & Public Relations is where faith meets action. We believe the church exists not just for itself but for the world around it. Our team organizes community projects and represents the church in the public sphere.",
      whatWeDo: [
        "Monthly community food distribution serving 150+ families",
        "Back-to-school supply drives and holiday giving programs",
        "Partnership with local shelters, schools, and nonprofits",
        "Manage church communications and public relations",
        "Coordinate community events and outreach initiatives"
      ],
      whoCanJoin: "Anyone with a heart to serve others and share God's love in practical ways. Opportunities for all ages and abilities — from event planning to hands-on service.",
    }
  },
  {
    img: "https://res.cloudinary.com/dsnontai6/image/upload/v1771543262/0A3A9526_db2ixl.jpg",
    tag: "Technical",
    title: "AGC Media Team",
    desc: "Operating sound, lighting, video, and livestream equipment to enhance worship and reach people online.",
    schedule: "Sundays & Events",
    details: {
      overview: "The AGC Media Team works behind the scenes to ensure every service runs smoothly and reaches as many people as possible — both in the building and online. Technology is our tool for expanding the Kingdom.",
      whatWeDo: [
        "Operate sound, lighting, and video systems during services",
        "Manage our weekly YouTube and Facebook Live streams",
        "Create and display graphics, lyrics, and sermon visuals",
        "Record and edit sermons and ministry content",
        "Maintain and develop our digital presence and website"
      ],
      whoCanJoin: "Anyone with an interest in technology, audio/visual production, or digital media. We welcome beginners and experienced technicians alike — we'll train you on our equipment.",
    }
  }
];

const DepartmentModal = ({ dept, onClose }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
      className="dept-modal-overlay"
      onClick={onClose}
    >
      <motion.div
        initial={{ opacity: 0, y: 60, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 40, scale: 0.95 }}
        transition={{ duration: 0.35, ease: "easeOut" }}
        className="dept-modal"
        onClick={e => e.stopPropagation()}
      >
        <button className="dept-modal-close" onClick={onClose}>×</button>

        <div className="dept-modal-image">
          <img src={dept.img} alt={dept.title} />
          <span className="department-tag">{dept.tag}</span>
        </div>

        <div className="dept-modal-body">
          <div className="dept-modal-header">
            <h2>{dept.title}</h2>
            <div className="dept-modal-schedule">
              <span className="meta-icon">📅</span>
              <span>{dept.schedule}</span>
            </div>
          </div>

          <p className="dept-modal-overview">{dept.details.overview}</p>

          <div className="dept-modal-section">
            <h4>What We Do</h4>
            <ul>
              {dept.details.whatWeDo.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="dept-modal-section">
            <h4>Who Can Join</h4>
            <p>{dept.details.whoCanJoin}</p>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

const Departments = () => {
  const [selectedDept, setSelectedDept] = useState(null);

  React.useEffect(() => {
    if (selectedDept) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [selectedDept]);

  // Close on Escape key
  React.useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') setSelectedDept(null); };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <div className="departments">
      <Header />

      {/* Hero Section */}
      <section className="hero4">
        <div className="hero-content4">
          <h1>Our Departments</h1>
          <p>Discover where you can serve, grow, and make an impact in our community</p>
        </div>
      </section>

      {/* Intro Section */}
      <motion.section 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="section4"
      >
        <div className="section-header4">
          <h2 className="section-title4">Get Involved</h2>
          <p className="section-subtitle4">Every person has unique gifts and talents. Explore our various departments and ministries to find where you can make a lasting impact and grow in your faith journey.</p>
        </div>
      </motion.section>

      {/* Departments Grid */}
      <motion.section 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.6 }}
        className="section4" 
        style={{ paddingTop: 0 }}
      >
        <div className="departments-grid">
          {departments.map((dept, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="department-card"
            >
              <div className="department-image">
                <img src={dept.img} alt={dept.title} />
                <span className="department-tag">{dept.tag}</span>
              </div>
              <div className="department-content">
                <h3>{dept.title}</h3>
                <p>{dept.desc}</p>
                {/* <div className="department-meta">
                  <div className="meta-item">
                    <span className="meta-icon">📅</span>
                    <span>{dept.schedule}</span>
                  </div>
                </div>
                <button
                  className="department-link"
                  onClick={() => setSelectedDept(dept)}
                >
                  Learn more
                </button> */}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* CTA Section */}
      <motion.section 
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.7 }}
        className="cta-section"
      >
        <h2>Ready to Get Involved?</h2>
        <p>We'd love to help you find the perfect place to serve. Connect with us and discover how you can use your gifts to make a difference.</p>
        <Link to="/connect" className="cta-button">Contact Us</Link>
      </motion.section>

      {/* Department Modal */}
      <AnimatePresence>
        {selectedDept && (
          <DepartmentModal
            dept={selectedDept}
            onClose={() => setSelectedDept(null)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default Departments;
